import { useState } from 'react';
import { Toast } from 'primereact/toast';
import { UmrsRoleList, UmrsRoleCreateDialog, UmrsRoleEditDialog } from '@authifi/clique-react-ui';
import type { UmrsRole } from '@authifi/clique-react-ui';
import { useEntityToasts } from '../hooks/useEntityToasts';

export function UmrsRolesPage() {
  const { toastRef, notifyCreated, notifyUpdated, notifyDeleted, notifySuccess, notifyError } =
    useEntityToasts('UMRS Role');
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [editingUmrsRole, setEditingUmrsRole] = useState<UmrsRole | null>(null);

  return (
    <div>
      <Toast ref={toastRef} />
      <h2 className="text-2xl font-semibold text-[var(--clique-fg)] mb-2">UMRS Roles</h2>
      <p className="text-[var(--clique-fg-muted)] mb-6">
        Manage UMRS roles and their configuration.
      </p>

      <UmrsRoleList
        onUmrsRoleSelect={setEditingUmrsRole}
        onCreateUmrsRole={() => setShowCreateDialog(true)}
      />

      <UmrsRoleCreateDialog
        visible={showCreateDialog}
        onHide={() => setShowCreateDialog(false)}
        onCreated={(role) => notifyCreated(role.name)}
      />

      <UmrsRoleEditDialog
        visible={editingUmrsRole !== null}
        onHide={() => setEditingUmrsRole(null)}
        umrsRole={editingUmrsRole}
        onUpdated={(role) => notifyUpdated(role.name)}
        onDeleted={notifyDeleted}
        onSuccess={notifySuccess}
        onError={notifyError}
      />
    </div>
  );
}
